import { Link, NavLink } from 'react-router-dom';

const MenuGroup = () => {
  return (
    <div className="menu-group">
      {[1].map((col, idx) => (
        <div key={idx} data-aos="fade-up" data-aos-delay={`${idx * 300}`} data-aos-duration="800">
          <h3 className="fw-bold">Quick Links</h3>
          <ul className="list-unstyled ">
            <li>
              <NavLink to="/">Home</NavLink>
            </li>

            <li>
              <NavLink to="/expertise">Expertise</NavLink>
            </li>
            <li>
              <NavLink to="/individuals">Individuals</NavLink>
            </li>
            <li>
              <NavLink to="/corporate">Corporates</NavLink>
            </li>
            <li>
              <NavLink to="/lawyers">Lawyers</NavLink>
            </li>
            <li>
              <NavLink to="/about">About Us</NavLink>
            </li>
            <li>
              <NavLink to="/contact-us">Contact Us</NavLink>
            </li>
          </ul>
        </div>
      ))}
    </div>
  );
};

export default MenuGroup;
